import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { FileUploader } from "react-drag-drop-files";
import { setSubLoading } from '../../Redux/Services/AuthSlice';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall, DropDownData, deleteData, FileUploadChild, initializeFilterData } from '../CommonComponents/CustomHooks';
import { BulkClearData, DownloadFileAtURL, ERRORDATALIST, HandleBulkInsertData, handleDownloadExcel, readFile } from '../CommonComponents/ExportData';
import { FormButton, ImportButton, InputBox, SelectInputBox, Switch } from '../CommonComponents/InputBox';
import { Table } from '../CommonComponents/Table';
import { base64ToBlob } from '../CommonComponents/EnvConfig';

import PopupWithIcon from '../CommonComponents/Popups';

import { CommonApiData } from '../CommonComponents/EnvConfig';

const ProductMaster = () => {
    const inputrefs = useRef([])
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [Status, setStatus] = useState([])
    const [ImportData, setImportData] = useState([])
    const [Name, setName] = useState('');
    const [formData, setFormData] = useState({
        productMasterID: '',
        productCode: 'System Generated',
        productName: '',
        productFamilyCode: '',
        dealerTypeCode: '',
        isIMEIApplicable: false,
        isActive: true,
        payByToken: false,
        productImage: '',
        productImageExt: '',
        productImageName:'',
    });
    const GetProductCode = DropDownData('GetProductFamilyMaster')
    const GetDealerType = DropDownData('GetDealerTypeMaster')

    const getProductMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        const data = {
            ...filterData,
            Type: 'S',
            PageIndex: `${PageIndex}`,
            ...sortConfig,
        }
        setIsLoading(true)
        let res = await ApiCall(`/api/Master/ShowProductMaster`, data)
        if (res.Status === "SUCCESS") {
            setTableData(res)
        }
        if (res.Status === "ERROR") {
            setTableData([])
        }
        setIsLoading(false)
        if (res.Status === 'EXPIRED') {
            await NotificationSound(res.Status, res.Message, res.focus, inputrefs);
        }
    }

    const handleClear = async() => {
        setFormData({
            productCode: 'System Generated',
            productName: '',
            productFamilyCode: '',
            dealerTypeCode: '',
            isIMEIApplicable: false,
            isActive: true,
            payByToken: false,
            productImage: '',
            productImageUrl: '',
            productImageExt: '',
            productImageName: '',
        });
        await setImportData([])
        await BulkClearData(setName)
        await setName('')
        await setStatus([])
        filterData.SearchText = '';
        setSortConfig({ SortColumn: null, SortOrder: null })
    }

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/Master/InsertUpdateProductMaster`, { ...formData })
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
    };

    const handleEditData = async (id) => {
        await dispatch(setSubLoading(true))
        let editData = await ApiCall(`/api/Master/EditProductMaster`, { ProductMasterId: id })
        await dispatch(setSubLoading(false))
        if (editData.status === 'UNAUTHORIZED' || editData.status === 'ERROR' || editData.status === 'EXPIRED') {
            await NotificationSound(editData.status, editData.message, editData.focus, inputrefs);
        }
        else {
            setFormData((pre) => ({
                ...pre, ...editData
            }))
        }
    }

    const OpenImage = (fileBase64, ext) => {
       
        if ((ext).toLowerCase() === 'pdf') {
            const blob = base64ToBlob(fileBase64, 'application/pdf');
            const url = URL.createObjectURL(blob);
            const pdfWindow = window.open(url, '_blank');
            if (!pdfWindow) {
                throw new Error("Please allow pop-ups for this site");
            }
            pdfWindow.document.title = "View PDF";
        } else {
            const blob = base64ToBlob(fileBase64, 'image/jpeg');
            const url = URL.createObjectURL(blob);
            const imageWindow = window.open(url, '_blank');
           
            if (!imageWindow) {
                throw new Error("Please allow pop-ups for this site");
            }
            imageWindow.document.title = "View Image";
        }
    }
    const EditOpenImage = (imageUrl, imageExt) => {
        const fullImageUrl = `${imageUrl}.${imageExt}`;
        window.open(fullImageUrl, '_blank'); 
    };

    const handleDelete = async (id) => {
        await dispatch(setSubLoading(true))
        await deleteData(`/api/Master/DeleteProductMaster`, { ProductMasterId: id }, getProductMasterData, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    }

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const handleChange1 = (event, value) => {
        getProductMasterData(value);
    };

    const DownloadFormat = async () => {
        await DownloadFileAtURL('ProductMaster.xlsx')
    };

    const ErrorData = async () => {
        await ERRORDATALIST(Status, 'ProductMasterError')
    }

    const BulkSubmit = async (e) => {
        await dispatch(setSubLoading(true))
        let data = await readFile(e)
        setImportData(data.exceljson)
        setName(data.FileName)
        await dispatch(setSubLoading(false))
    };

    const handleBulk = async () => {
        const Data2 = {
            "authToken": CommonApiData().AuthToken,
            "loginToken": CommonApiData().LoginToken,
            "loginUserCode": CommonApiData().UserCode,
            "companyCode": CommonApiData().CompanyCode,
            productCode: 'System Generated',

        };
        if (ImportData.length !== 0) {
            if ((Object.keys(ImportData[0])).includes("productName", "productFamilyCode", "dealerTypeCode", "isActive")) {
                await dispatch(setSubLoading(true))
                let Data = await HandleBulkInsertData('/api/Master/InsertUpdateProductMaster', ImportData, Data2, getProductMasterData)
                await setStatus(Data)
                await dispatch(setSubLoading(false))
                await NotificationSound('INFO', `Success : ${Data.SuccessCount} Error : ${Data.ErrorCount}`);
                BulkClearData(setName)

            } else {
                await NotificationSound('ERROR', 'Header Format is not valid !');
                BulkClearData(setName)
            }
        } else {
            await NotificationSound('ERROR', 'Please Choose File With Valid Data.!');
            BulkClearData(setName)
        }
    }

    useEffect(() => {
        getProductMasterData()
        document.title = 'Product Master'
        inputrefs.current['txtProductName'].focus()
    }, [sortConfig])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='pt-1 row px-3 border-0'>
                    <div className='card-header mb-1'>
                        <h6 className="m-0">  {'Product Master'} </h6>
                    </div>
                    <div className='card-body pb-1 row'>
                        <div className='col-md-6 col-lg-8'>
                            <div className='row'>
                                <InputBox
                                    id="txtProductCode"
                                    type="text"
                                    label='Product Code'
                                    divclassname="col-lg-4 col-md-4 col-sm-12 mb-1"
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtProductName'].focus()
                                        }
                                    }}
                                    inputrefs={inputrefs}
                                    placeholder='System Generated'
                                    name='ProductCode'
                                    value={formData.productCode}
                                    disabled
                                />
                                <InputBox
                                    id="txtProductName"
                                    type="text"
                                    label='Product Name'
                                    divclassname="col-lg-4 col-md-4 col-sm-12 mb-1"
                                    required={true}
                                    placeholder="Product Name"
                                    maxLength='200'
                                    value={formData.productName}
                                    onChange={(e) => setFormData({ ...formData, productName: e.target.value })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtProductFamilyCode'].focus()
                                        }
                                    }}
                                />
                                <SelectInputBox
                                    id="txtProductFamilyCode"
                                    value={formData.productFamilyCode}
                                    label='Product Family'
                                    divclassname="col-lg-4 col-md-4 col-sm-12 mb-1"
                                    required={true}
                                    onChange={(e) => setFormData({ ...formData, productFamilyCode: e.target.value })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtDealerType'].focus()
                                        }
                                    }}
                                >
                                    <option value=''>--Please Select--</option>
                                    {GetProductCode?.data?.dataList?.map((item, index) =>
                                        <option key={item.name + index} value={item.code}>{item.name}</option>
                                    )}
                                </SelectInputBox>
                                <SelectInputBox
                                    id="txtDealerType"
                                    value={formData.dealerTypeCode}
                                    divclassname="d-none"
                                    //divclassname="col-lg-4 col-md-4 col-sm-12 mb-1"
                                    label='Dealer Type'
                                    required={true}
                                    onChange={(e) => setFormData({ ...formData, dealerTypeCode: e.target.value })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtIsIMEIApplicable'].focus()
                                        }
                                    }}
                                >
                                    <option value=''>--Please Select--</option>
                                    {GetDealerType?.data?.dataList?.map((item, index) =>
                                        <option key={item.name + index} value={item.code}>{item.name}</option>
                                    )}
                                </SelectInputBox>
                                <div
                                    className='col-sm-3 sale'
                                    ref={ref => (inputrefs.current['txtTermsCondition'] = ref)}  >
                                    <label className="form-label">Product Terms Condition</label>
                                    <FileUploader
                                        classes="upload-section file-uploader"
                                        label="Upload Document"
                                        handleChange={async (file) => {
                                            let extArr = file.name.split(".");
                                            if (file) {
                                               
                                                try {
                                                    //if (file.size < 2 * 1024 * 1024) {
                                                    //    if (file.size > 200 * 1024) {
                                                    //        if (extArr[1].toUpperCase() === "JPG" || extArr[1].toUpperCase() === "PNG" || extArr[1].toUpperCase() === "PDF") {
                                                    //            const options = {
                                                    //                maxSizeMB: 0.2,
                                                    //                useWebWorker: true,
                                                    //            };
                                                    //            await dispatch(setSubLoading(true));
                                                    //        } else {
                                                    //            alert(`File type ${extArr[1].toUpperCase()} compression is not supported. Please upload a smaller file.`);
                                                    //            return;
                                                    //        }
                                                    //    }
                                                    //    const reader = new FileReader();
                                                    //    reader.readAsDataURL(file);
                                                    //    reader.onload = () => {
                                                    //        let logo = (reader.result).split(",")[1];
                                                    //        setFormData({
                                                    //            ...formData,
                                                    //            imeiImage: logo,
                                                    //            imeiExt: extArr[1],
                                                    //            imeiName: extArr[0],
                                                    //        });
                                                    //    };
                                                    //} else {
                                                    //    NotificationSound('ERROR', 'Please upload maximum 2 mb image .!')
                                                    //}
                                                    
                                                    const reader = new FileReader();
                                                    reader.readAsDataURL(file);
                                                    reader.onload = () => {
                                                        let logo = (reader.result).split(",")[1];
                                                        setFormData({
                                                            ...formData,
                                                            productImage: logo,
                                                            productImageExt: extArr[1],
                                                            productImageName: extArr[0],
                                                        });
                                                    };
                                                } catch (error) {
                                                    console.error("File handling error:", error);
                                                    alert("An error occurred while processing the file. Please try again.");
                                                }
                                            }
                                        }}
                                        name="file"
                                        types={["JPG", "PNG","PDF"]}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter" || e.key === "Tab") {
                                                e.preventDefault();
                                                inputrefs.current["txtActive"].focus();
                                            }
                                        }}
                                        children={
                                            <FileUploadChild
                                                label=""
                                                message={`${formData.productImageName}.${formData.productImageExt}`}
                                                types={["JPG", "PNG","PDF"]}
                                            />
                                        }
                                    />

                                    {formData.productImage ?
                                        <i className="fa fa-image me-2"
                                            title='show Image'
                                            onClick={() => { OpenImage(formData.productImage, formData.productImageExt) }}
                                            style={{ cursor: 'pointer', color: '#5a8dee', fontSize: '14px' }}
                                        /> : <span className='text-danger' style={{ fontSize: '12px' }}></span>
                                    }
                                </div>
                                <Switch
                                    inputrefs={inputrefs}
                                    divclassname="d-none"
                                    label='IMEI Applicable'
                                    checked={formData.isIMEIApplicable}
                                    id='txtIsIMEIApplicable'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtActive'].focus()
                                        };
                                    }}
                                    onChange={(e) => setFormData({ ...formData, isIMEIApplicable: e.target.checked })}
                                />


                                <Switch
                                    inputrefs={inputrefs}
                                    label='Active'
                                    checked={formData.isActive}
                                    id='txtActive'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtpayByTokenActive'].focus()
                                        };
                                    }}
                                    onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
                                />
                                <Switch
                                    inputrefs={inputrefs}
                                    label='Pay By Token'
                                    divclassname="d-none"
                                    checked={formData.payByToken}
                                    id='txtpayByTokenActive'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['btnSub'].focus()
                                        };
                                    }}
                                    onChange={(e) => setFormData({ ...formData, payByToken: e.target.checked })}
                                />
                            </div>
                        </div>
                        <div className='d-flex col-md-6 col-lg-4 h-65 mb-2'>
                            <ImportButton
                                handleBulk={handleBulk}
                                BulkSubmit={(e) => BulkSubmit(e)}
                                downloadFormat={DownloadFormat}
                                ErrorData={ErrorData}
                                Status={Status}
                                HeaderFormat="PayMode, Active"
                                fileName={Name}
                            >
                            </ImportButton>
                        </div>
                        <div className='card-body'>
                            <FormButton
                                id={'btnSub'}
                                inputrefs={inputrefs}
                                handleSubmit={handleSubmit}
                                handleExport={() => handleDownloadExcel(`/api/Master/ShowProductMaster`, filterData, 'Product Master')}
                                handleClear={handleClear}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Table
                handleEdit={handleEditData}
                handleDelete={handleDelete}
                loading={isLoading}
                PageName={'ProductMaster'}
                handleFilter={() => {
                    getProductMasterData()
                    setFilterData({
                        ...filterData,
                    })
                }}
                filterData={filterData}
                tableData={tableData}
                setFilterData={setFilterData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
            />
        </>
    )
}
export default ProductMaster;